import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// ส่วนที่เก็บคำแปล (Resources)
const resources = {
  en: {
    translation: {
      "welcome": "Welcome to React",
      "change_lang": "Change Language"
    }
  },
  th: {
    translation: {
      "welcome": "ยินดีต้อนรับสู่ React",
      "change_lang": "เปลี่ยนภาษา"
    }
  }
};

i18n
  .use(initReactI18next) // เชื่อมต่อกับ React
  .init({
    resources,
    lng: "en", // ภาษาเริ่มต้น (ตั้งเป็นอังกฤษตามที่คุณต้องการ)
    interpolation: {
      escapeValue: false // React จัดการเรื่อง XSS ให้แล้ว
    }
  });

export default i18n;